import { BaseRouteService } from 'core/services';

class RateServiceRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'rate-service/';
	}

	getAmazonShippingServices = () => {
		return super.create(this.base + 'amazon-shipping-services');
	};

	findCarrierServiceWithRates = filter => {
		return super.create(this.base + 'carrier-service-rates', filter);
	};

	fetchRates = () => {
		return this.uriTemplateService.parse(`${this.base}fetch-rates`).expand();
	};

	getRates = rateParams => {
		return super.create(this.base + 'get-rates', rateParams);
	};
}

export default RateServiceRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/RateServiceRouteService.js